import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CategoryTotal } from '../../models/search-result';

@Component({
    selector: 'celine-threshold-search-category-checkbox',
    template: require('./search-category-checkbox.component.html')
})

export class SearchCategoryCheckboxComponent {
    @Input() categoryTotal: CategoryTotal;
    @Output() changed = new EventEmitter<{ category: string, checked: boolean}>();

    constructor() {

    }

    onChange(state: boolean) {
        this.categoryTotal.checked = state;
        this.changed.emit({ category: this.categoryTotal.name, checked: state });
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/search/search-category-checkbox.component.ts